import { ThemeColors } from "@/config/theme/themeTypes";

/**
 * Mapea las keys del ThemeConfig a las keys que Vuetify reconoce en su
 * `theme` (Fase 35b.3).
 *
 * Vuetify 1.5 espera al menos: primary, secondary, accent, error, info,
 * success, warning. Mapping:
 *   - colors.primary  → primary
 *   - colors.secondary → secondary
 *   - colors.success  → success
 *   - colors.warning  → warning
 *   - colors.danger   → error (Vuetify nombra "error" lo que el theme llama "danger")
 *   - colors.info     → info
 *
 * Las claves Vuetify legacy del repo (rclaro, invest, mont, rent, pend,
 * etc.) se conservan en main.ts y NO se sobrescriben aquí — quedan como
 * deuda separada hasta que los componentes que las usan migren a las
 * variables del themeService.
 */
export function themeColorsToVuetify(colors: ThemeColors): Record<string, string> {
  return {
    primary:   colors.primary,
    secondary: colors.secondary,
    success:   colors.success,
    warning:   colors.warning,
    error:     colors.danger,
    info:      colors.info
  };
}
